(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shared NLF scroll reveal. Every NLF section ships this block, it only runs once.
    if (window.nlfReveal) return;
    window.nlfReveal = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nlf-reveal]').forEach((el) => el.classList.add('nlf-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nlf-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    const scan = (scope) => {
      scope.querySelectorAll('[data-nlf-reveal]:not(.nlf-is-visible)').forEach((el) => observer.observe(el));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    // Theme editor: re-observe sections after they are re-rendered
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shared NLF scroll reveal. Every NLF section ships this block, it only runs once.
    if (window.nlfReveal) return;
    window.nlfReveal = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nlf-reveal]').forEach((el) => el.classList.add('nlf-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nlf-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    const scan = (scope) => {
      scope.querySelectorAll('[data-nlf-reveal]:not(.nlf-is-visible)').forEach((el) => observer.observe(el));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    // Theme editor: re-observe sections after they are re-rendered
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const refreshCount = async () => {
      const badges = document.querySelectorAll('[data-nlf-cart-count]');
      if (!badges.length) return;
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        badges.forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      } catch (e) {
        /* keep the server-rendered count */
      }
    };

    // Horizon dispatches cart:update after add-to-cart and line changes
    document.addEventListener('cart:update', refreshCount);
  })();

  (() => {
    if (window.nlfHeaderScroll) return;
    window.nlfHeaderScroll = true;

    // Horizon scrolls .page-wrapper on desktop (html and body are overflow: hidden there)
    // and the window on mobile, so read both.
    const scrollY = () => {
      const wrapper = document.querySelector('.page-wrapper');
      return Math.max(window.scrollY || 0, wrapper ? wrapper.scrollTop : 0);
    };

    const update = () => {
      const y = scrollY();
      document.querySelectorAll('[data-nlf-header]').forEach((header) => {
        const threshold = parseInt(header.dataset.scrollThreshold, 10) || 0;
        header.classList.toggle('nlf-header--scrolled', y > threshold);
        header.style.setProperty('--hdr-h', `${header.offsetHeight}px`);
      });
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    // Scroll events of elements do not bubble, so listen in the capture phase
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('shopify:section:load', update);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', update);
    } else {
      update();
    }
  })();

  (() => {
    if (window.nlfHeaderDrawer) return;
    window.nlfHeaderDrawer = true;

    const closeDrawers = () => {
      document.querySelectorAll('.nlf-header__drawer[open]').forEach((drawer) => {
        drawer.open = false;
      });
    };

    // Choosing a menu link closes the menu first, so the page behind is visible and the click clearly worked
    document.addEventListener('click', (event) => {
      if (event.target.closest && event.target.closest('.nlf-header__panel a')) closeDrawers();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawers();
    });

    // Back button and window resize must not leave an open menu behind
    window.addEventListener('pageshow', closeDrawers);
    if (window.matchMedia) {
      const wide = window.matchMedia('(min-width: 900px)');
      const onChange = (event) => {
        if (event.matches) closeDrawers();
      };
      if (wide.addEventListener) wide.addEventListener('change', onChange);
      else if (wide.addListener) wide.addListener(onChange);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shared NLF scroll reveal. Every NLF section ships this block, it only runs once.
    if (window.nlfReveal) return;
    window.nlfReveal = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nlf-reveal]').forEach((el) => el.classList.add('nlf-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nlf-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    const scan = (scope) => {
      scope.querySelectorAll('[data-nlf-reveal]:not(.nlf-is-visible)').forEach((el) => observer.observe(el));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    // Theme editor: re-observe sections after they are re-rendered
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-merch-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shared NLF scroll reveal. Every NLF section ships this block, it only runs once.
    if (window.nlfReveal) return;
    window.nlfReveal = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nlf-reveal]').forEach((el) => el.classList.add('nlf-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nlf-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    const scan = (scope) => {
      scope.querySelectorAll('[data-nlf-reveal]:not(.nlf-is-visible)').forEach((el) => observer.observe(el));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    // Theme editor: re-observe sections after they are re-rendered
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-newsletter-social"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shared NLF scroll reveal. Every NLF section ships this block, it only runs once.
    if (window.nlfReveal) return;
    window.nlfReveal = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nlf-reveal]').forEach((el) => el.classList.add('nlf-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nlf-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    const scan = (scope) => {
      scope.querySelectorAll('[data-nlf-reveal]:not(.nlf-is-visible)').forEach((el) => observer.observe(el));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    // Theme editor: re-observe sections after they are re-rendered
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  (() => {
    if (window.nlfBrevoForm) return;
    window.nlfBrevoForm = true;

    // Bring the confirmation into view and announce it to screen readers
    const showDone = (element) => {
      const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      element.focus({ preventScroll: true });
      element.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
    };

    // Shopify form: the page reloads after sign-up, so show the confirmation on load
    const showReloadedDone = () => {
      document.querySelectorAll('[data-nlf-done]:not([hidden])').forEach(showDone);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showReloadedDone);
    } else {
      showReloadedDone();
    }

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || !form.matches || !form.matches('[data-nlf-brevo]')) return;
      // Without fetch the form simply posts to Brevo the classic way
      if (!window.fetch || !window.FormData) return;

      event.preventDefault();
      if (form.checkValidity && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const fields = form.querySelector('[data-nlf-brevo-fields]');
      const done = form.querySelector('[data-nlf-done]');
      const error = form.querySelector('[data-nlf-brevo-error]');
      const button = form.querySelector('button[type="submit"]');
      error.hidden = true;
      if (button) button.disabled = true;

      // no-cors: the request reaches Brevo, but Brevo's answer cannot be read from here
      fetch(form.action, { method: 'POST', body: new FormData(form), mode: 'no-cors' })
        .then(() => {
          fields.hidden = true;
          done.hidden = false;
          showDone(done);
        })
        .catch(() => {
          error.hidden = false;
          if (button) button.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-release"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Shared NLF scroll reveal. Every NLF section ships this block, it only runs once.
    if (window.nlfReveal) return;
    window.nlfReveal = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nlf-reveal]').forEach((el) => el.classList.add('nlf-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nlf-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    const scan = (scope) => {
      scope.querySelectorAll('[data-nlf-reveal]:not(.nlf-is-visible)').forEach((el) => observer.observe(el));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    // Theme editor: re-observe sections after they are re-rendered
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-tour-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('nlf-tour-list')) return;

    class NlfTourList extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-tour-load-more]');
        if (!this.button) return;

        this.step = parseInt(this.dataset.step, 10) || 5;
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      onClick() {
        const hiddenItems = Array.from(this.querySelectorAll('[data-tour-item][hidden]'));
        const batch = hiddenItems.slice(0, this.step);

        batch.forEach((item, index) => {
          item.style.setProperty('--nlf-i', index);
          item.hidden = false;
        });

        // Move focus to the first revealed row so keyboard and screen reader users land on the new content
        if (batch.length) {
          batch[0].setAttribute('tabindex', '-1');
          batch[0].focus({ preventScroll: true });
        }

        if (hiddenItems.length <= this.step) {
          const wrapper = this.querySelector('[data-tour-more]');
          if (wrapper) wrapper.hidden = true;
        }
      }
    }

    customElements.define('nlf-tour-list', NlfTourList);
  })();

  (() => {
    // Shared NLF scroll reveal. Every NLF section ships this block, it only runs once.
    if (window.nlfReveal) return;
    window.nlfReveal = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nlf-reveal]').forEach((el) => el.classList.add('nlf-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nlf-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    const scan = (scope) => {
      scope.querySelectorAll('[data-nlf-reveal]:not(.nlf-is-visible)').forEach((el) => observer.observe(el));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    // Theme editor: re-observe sections after they are re-rendered
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nlf-video-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.nlf-video__play');
      if (!button) return;
      const iframe = document.createElement('iframe');
      iframe.title = button.dataset.nlfTitle || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.src = button.dataset.nlfYoutube
        ? `https://www.youtube-nocookie.com/embed/${button.dataset.nlfYoutube}?autoplay=1&rel=0`
        : `https://player.vimeo.com/video/${button.dataset.nlfVimeo}?autoplay=1&dnt=1`;
      button.replaceWith(iframe);
      iframe.focus();
    });
  })();

  (() => {
    // Shared NLF scroll reveal. Every NLF section ships this block, it only runs once.
    if (window.nlfReveal) return;
    window.nlfReveal = true;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-nlf-reveal]').forEach((el) => el.classList.add('nlf-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nlf-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    const scan = (scope) => {
      scope.querySelectorAll('[data-nlf-reveal]:not(.nlf-is-visible)').forEach((el) => observer.observe(el));
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
      scan(document);
    }
    // Theme editor: re-observe sections after they are re-rendered
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
